import styled from "styled-components";

export const SingleOrderWrapper = styled.div`
    margin-top: 10px;
`;

// Collapsed accordion head: shows the record title, labels and the
// SQL-driven background color. Click expands the full form below.
export const AccordionHead = styled.div<{ $open?: boolean; $background_color?: string }>`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 14px;
    cursor: pointer;
    user-select: none;
    background-color: ${props => `${props.$background_color ?? '#ffffff'}`};
    border: 1px solid #e8e8e6;
    border-radius: ${props => (props.$open ? '12px 12px 0 0' : '12px')};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    &:hover {
        border-color: #c8cdf3;
    }
`;

export const AccordionTitle = styled.span`
    font-weight: 600;
    font-size: 13.5px;
`;

export const AccordionChevron = styled.span<{ $open?: boolean }>`
    color: #9a9a94;
    font-size: 11px;
    transition: transform 0.15s ease;
    transform: ${props => (props.$open ? 'rotate(90deg)' : 'none')};
`;

// Labels must stay selectable: the head's user-select/cursor are overridden
// and the toggle click is stopped in SingleOrder.tsx.
export const AccordionLabels = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
    user-select: text;
    cursor: text;
`;

// Record actions (edit/delete) rendered at the right edge of the head.
export const AccordionActions = styled.span`
    margin-left: auto;
    display: inline-flex;
    align-items: center;
`;

export const SingleOrderFormWrapper = styled.div<{ $background_color?: string }>`
    background-color:  ${props => `${props.$background_color ?? ' #f8f8f8'}`};
    padding: 10px;
    border-radius: 0 0 12px 12px;
    border: 1px solid #e8e8e6;
    border-top: none;

    /* Compact vertical rhythm inside an expanded record */
    .ant-form-item {
        margin-bottom: 6px;
    }
`;

